"use strict";
import React,{useRef, useState, useImperativeHandle, useEffect } from 'react';
import loadable from "@loadable/component";
const DocumentPreview = loadable(() => import(/* webpackChunkName: "jd-document-preview" */'jd-library/DocumentPreview'));
import withPortal from 'jd-library/withPortal';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
const DocumentPreviewPortal = withPortal(DocumentPreview);
const ImagePreview = React.forwardRef(
    (
        {
            imageList= [],
            isMobile,
            keepTextFixed=false,
            textPlacement='',
            ...props
        },
        ref
    ) => {
        const previewRef = useRef(null);
        const [showPreview, setShowPreview] = useState(false);
        const [clickedImageIndex, setIndex] = useState(0);
        const [previewIndex, setPreviewIndex] = useState(0);
        useImperativeHandle(ref, () => ({
            onImageClick(option) {
                setShowPreview(true);
                setIndex(option.clickedImageIndex);
                //previewRef.current.onImageClick(option);
            }
        }), [ref]);
        const location = useLocation();
        useEffect(() => {
            let search = parse(location.search);
            if(search.prescriptionId && imageList.length && !showPreview){
                let prevIndex = '';
                imageList.map((cur,index) => {
                    if(search.prescriptionId == cur.fileId){
                        prevIndex = index;
                    }
                })
                setShowPreview(true);
                setIndex(prevIndex);
            }
        },[imageList]);
        // const onCustomClick = (direction) => {
        //     if(direction ==='left')
        //     // setIndex(clickedImageIndex-1);
        //     setPreviewIndex(previewIndex-1);

        //     else if(direction ==='right')
        //     // setIndex(clickedImageIndex-1);
        //     setPreviewIndex(previewIndex+1);
        //     else setPreviewIndex(previewIndex)
            
        //     console.log('onCustomClick', previewIndex);
        // }
        return (
            <>
                {showPreview ?
                    <DocumentPreviewPortal 
                        imageList={imageList} 
                        ref={previewRef} 
                        isMobile={false} 
                        keepTextFixed={keepTextFixed}
                        textPlacement={textPlacement}
                        showHideCb = {action => {
                            action == 'hide' && setTimeout(() => {
                                setShowPreview(false);
                            }, 300);
                        }}
                        renderMode={"canvas"}
                        
                        clickedImageIndex={clickedImageIndex}
                        customClass ={"custom-arrow"}
                        // onCustomClick={onCustomClick}
                    />
                    : null
                }
            </>
        );
    }
);
export default ImagePreview;